module.exports = __webpack_public_path__ + "img/second-day-5.43047a8a.webp";